import React from "react";
import { TableBodyProps } from "@mui/material/TableBody";

import { TableRow } from "../../UI/TableRow";
import { Skeleton } from "../../UI/Skeleton";
import { TableCell } from "../../UI/TableCell";
import { TableBody } from "../../UI/TableBody";

// import { Progress } from "../Progress";

import { useTableBodyState } from "./useTableBodyState";

export enum TableState {
  Default = "Default",
  Loading = "Loading",
  Empty = "Empty",
}

export interface IProps extends TableBodyProps {
  colSpan: number;
  isLoading?: boolean;
}

const EnhancedTableBody: React.FC<IProps> = React.forwardRef((props, ref) => {
  const tableState = useTableBodyState(React.Children.toArray(props.children).length, props.isLoading);

  return (
    <TableBody ref={ref}>
      {tableState === TableState.Loading && (
        <>
          <TableRow>
            <TableCell align="center" colSpan={props.colSpan}>
              <Skeleton variant="rectangular" width="100%" height={36} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center" colSpan={props.colSpan}>
              <Skeleton variant="rectangular" width="100%" height={36} />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center" colSpan={props.colSpan}>
              <Skeleton variant="rectangular" width="100%" height={36} />
            </TableCell>
          </TableRow>
        </>
      )}
      {tableState === TableState.Empty && (
        <TableRow>
          <TableCell align="center" colSpan={props.colSpan}>
            Empty
          </TableCell>
        </TableRow>
      )}
      {tableState === TableState.Default && props.children}
    </TableBody>
  );
});

EnhancedTableBody.defaultProps = {
  isLoading: false,
};

export { EnhancedTableBody };
